import axiosInstance from 'services/axiosInstance';
import { ICallScribeParticipant } from 'services/callScribe/types';
import { IResponse } from 'services/types';

export const SPEAKER_NAME_ERROR = 'Enter a name of 1 to 100 characters.';

// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f-\u009f]/;

export const validateSpeakerName = (raw: string): string | null => {
  const name = raw.trim();
  if (name.length < 1 || name.length > 100 || CONTROL_CHARS.test(name) || /[<>]/.test(name)) {
    return SPEAKER_NAME_ERROR;
  }
  return null;
};

export const renameCallScribeParticipant = (
  callId: number,
  participantId: number,
  displayName: string,
): IResponse<ICallScribeParticipant> =>
  axiosInstance.request({
    method: 'PATCH',
    url: `call-scribe/calls/${callId}/participants/${participantId}`,
    data: { displayName },
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });
